import { ReactNode, useMemo, useState } from 'react';
import { ITableContext, TableContext } from 'components/table/TableContext';

interface TableRootProps<T> extends Omit<ITableContext<T>, 'isActionHidden' | 'setIsActionHidden'> {
    children: ReactNode;
}

const TableRoot = <T,>(props: TableRootProps<T>) => {
    const { children, variant = 'none', table, ...rest } = props;
    const [isActionHidden, setIsActionHidden] = useState(false);

    const providerProps = useMemo(
        () => ({
            variant,
            table,
            isActionHidden,
            setIsActionHidden,
            ...rest,
        }),
        [rest, table, variant, isActionHidden],
    );

    if (!table) {
        // eslint-disable-next-line no-console
        console.error('A table instance must be provided.');
        return null;
    }

    return <TableContext.Provider value={providerProps}>{children}</TableContext.Provider>;
};

export { TableRoot };
export type { TableRootProps };
